import $ from 'jquery';
import pjax from '@/vendor/pjax/pjax';

/**
 * This module handles selecting the per-page option from the pagination dropdown.
 */
const updateURLParameter = function (url, param, paramVal, ignore) {
	let newAdditionalURL = '';
	let tempArray = url.split('?');
	const additionalURL = tempArray[1];
	let currentParam = '';
	let temp = '';

	if (additionalURL) {
		tempArray = additionalURL.split('&');

		for (let i = 0; i < tempArray.length; i++) {
			currentParam = tempArray[i].split('=')[0];
			if (currentParam === param || currentParam === ignore) {
				continue;
			}

			newAdditionalURL += temp + tempArray[i];
			temp = '&';
		}
	}

	const rowsTxt = temp + '' + param + '=' + paramVal;

	return newAdditionalURL + rowsTxt;
};

const initPaginationSelector = () => {
	$('.content').on('change', '.per-page', function () {
		const data = updateURLParameter(window.location.href, 'per_page', $(this).val(), 'page');

		pjax.navigate({ url: window.location.href.split('?')[0], data: data, container: '#pjaxContainer', method: 'GET' });
	});
};

export default initPaginationSelector;
